import React from 'react'
import { slide as Menu } from 'react-burger-menu';
import ButtonNavigator from './ButtonNavigator';
import '../customstyles/Sidebar.css'
import { useAuth } from '../contexts/AuthContext';
import AdminButtonNavigator from './AdminButtonNavigator';


export default function SideMenu(props) {
  const {userRole} = useAuth();
  return (
    <Menu>
        {userRole === 'Administrator' ?
            <AdminButtonNavigator page={props.name}></AdminButtonNavigator>
            :
            <ButtonNavigator page={props.name}></ButtonNavigator>
        }      
    </Menu>
  )
}
